import {
  borderRadius,
  customScrollMinimal,
  SmartTable,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleMd};
`;

export const DescriptionLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const TableWrapper = styled.div<{ $isCollapsed: boolean }>`
  overflow: auto;
  ${customScrollMinimal};

  ${({ $isCollapsed }) =>
    !$isCollapsed &&
    css`
      max-height: 1000px;
    `}

  ${SmartTable.Styled.StyledTableRow} {
    cursor: default;
  }

  tbody ${SmartTable.Styled.StyledTableRow}:last-child td {
    border-bottom: none;
  }

  ${borderRadius.r2};
  border: 1px solid var(--border-soft);
`;

export const FilterWrapper = styled.div`
  align-self: end;
`;

export const ViewMoreWrapper = styled.div`
  align-self: start;
`;
